import axios from "axios"
import { API_URLs } from "../../utilities/API_URLs"
import { API_BASE_URL } from "../../utilities/API_CONSTANT"

export const refreshToken = (refresh_token: string) => {
  return axios.post(API_BASE_URL + API_URLs.auth.postRefreshToken, {
    refresh_token,
  })
  .then(r => r.data)
  .catch(e => null)
}